import React from 'react';
import Image from './Image';
import { IBlockBenefits } from './IBlocks';
import * as styles from './Benefits.module.scss';

type Props = {


}

export default function Benefits (props: Props & IBlockBenefits) {
    const { image, points} = props;


    return  <div className="container">
            <div className="columns">
                <div className="column is-hidden-mobile">
                    <Image src={image.src} alt={image.alt} title={image.title} />
                </div>

                <div className="column">
                    <div className="content">
                        <h3> Ihre Vorteile </h3>
                        <ul className={styles.benefitsWrapper}>
                                {points.map((benefit, key) => <li key={key} className={styles.benefitsItem}>{benefit}</li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    
}